import { TitanSprite } from "../../control/TitanSprite";
/**
 * Background.ts
 */
export class Background extends TitanSprite {
    create() {
        super.create();
        this.landscapeSprite.anchor.set(0.5);
        if (this.hasPortraitProperties) {
            this.portraitSprite.anchor.set(0.5);
        }
    }
    handleResize(event) {
        const gameSize = this.renderer.getGameSize();
        this.x = gameSize.x / 2;
        this.y = gameSize.y / 2;
        let scale = 1;
        this.scale.set(scale);
        if (this.width < gameSize.x) {
            scale = gameSize.x / this.width;
        }
        if (this.height < gameSize.y) {
            scale = Math.max(scale, this.height / gameSize.y);
        }
        this.scale.set(scale);
    }
}
//# sourceMappingURL=Background.js.map